import React from 'react';

import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';

import LeaguesTable from '../LeaguesTableWrapper';
import { StyledTableRow } from '../../Styled';
import { SportTypeIds } from '../../../utils/types';
import { sessionStandingsHeadCells } from '../../../utils/constants';
import { getPowerIndex } from '../../../utils/helpers';

const SessionStandingsTable = ({ sessionStandings = [], isLoading, sportTypeId }) => {
    const TeamTableRow = ({ rowData, labelId }) => {
        const {
            id,
            teamName,
            homeCourtLocation,
            teamMatchWins,
            teamMatchLosses,
            playerMatchPoints,
            playerMatchGameWinPercentage,
            teamId,
            rank,
            teamPowerIndex
        } = rowData;

        const gamesWonPercentage = (playerMatchGameWinPercentage * 100).toFixed(2);
        const teamUrl = `/teams/${teamId}`;

        return (
            <StyledTableRow tabIndex={-1} key={id}>
                <TableCell component="th" id={labelId} scope="row" padding="normal">
                    <Typography>{rank}</Typography>
                </TableCell>
                <TableCell>
                    <Stack>
                        <Link fontSize="1rem" href={teamUrl}>
                            {teamName}
                        </Link>
                        <Typography variant="cardSubtitle">{homeCourtLocation?.placeName || ''}</Typography>
                    </Stack>
                </TableCell>
                <TableCell>
                    <Typography>{getPowerIndex(teamPowerIndex?.singlesRating, teamPowerIndex?.isSinglesEstimated)}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{getPowerIndex(teamPowerIndex?.doublesRating, teamPowerIndex?.isDoublesEstimated)}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{teamMatchWins}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{teamMatchLosses}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{playerMatchPoints}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{`${gamesWonPercentage}%`}</Typography>
                </TableCell>
            </StyledTableRow>
        );
    };

    const percentageLabel = sportTypeId === SportTypeIds.TENNIS ? 'Games Won' : 'Pts won %';
    const standingsHeadCells = [...sessionStandingsHeadCells, { id: 'playerMatchGameWinPercentage', label: percentageLabel }];

    return (
        <LeaguesTable sortBy="rank" tableData={sessionStandings} headCells={standingsHeadCells} isLoading={isLoading} rowComponent={TeamTableRow} />
    );
};

export default SessionStandingsTable;
